import toNumber from './toNumber.js';

/**
 * Creates a function that performs a relational operation on two values.
 *
 * @private
 * @param {Function} operator The function to perform the operation.
 * @returns {Function} Returns the new relational operation function.
 */
function createRelationalOperation(operator) {
  return function(value, other) {
    if (!(typeof value == 'string' && typeof other == 'string')) {
      value = toNumber(value);
      other = toNumber(other);
    }
    return operator(value, other);
  };
}

export default createRelationalOperation;



//////////////////
// WEBPACK FOOTER
// ./~/lodash-es/_createRelationalOperation.js
// module id = 210
// module chunks = 0